import React from 'react';
import { Link } from 'react-router-dom';

export default function NewsletterSubscribedPage() {
  return (
    <main className="relative overflow-hidden border-b border-[#d3e4e4] bg-[#eaf5f5] px-5 py-8 text-[#20302d] sm:px-8 md:py-12">
      <div aria-hidden="true" className="absolute -right-24 -top-24 h-72 w-72 rounded-full border border-[#c6dddd]" />
      <div aria-hidden="true" className="absolute -bottom-40 -left-32 h-96 w-96 rounded-full border border-[#d2e6e5]" />

      <section className="hero-animate relative mx-auto max-w-[820px]">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#d7eee8] text-[#14705e] shadow-[0_8px_24px_rgba(20,112,94,0.10)]">
          <svg aria-hidden="true" className="h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path d="m6.5 12.5 3.2 3.2 7.8-8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
          </svg>
        </div>

        <h1 className="mt-5 max-w-[760px] text-[36px] font-semibold leading-[1.14] tracking-[-0.025em] text-[#14201d] sm:text-[44px] md:text-[50px]">
          You’re subscribed to the MedHug Newsletter.
        </h1>
        <p className="mt-6 max-w-[650px] text-[18px] leading-8 text-[#3e5551] md:text-[20px]">
          Watch your inbox for practical Medicare coverage and medication-access updates created for healthcare professionals.
        </p>
        <p className="mt-3 text-[14px] leading-6 text-[#60726e]">
          If this address was already subscribed, nothing has changed.
        </p>

        <div className="mt-7">
          <Link
            className="inline-flex items-center justify-center rounded-full bg-[#075eaf] px-6 py-3 text-[15px] font-semibold text-white transition-colors hover:bg-[#064f93]"
            to="/resources/newsletter"
          >
            Read newsletters
            <span aria-hidden="true" className="ml-2">→</span>
          </Link>
        </div>

        <div className="mt-10 border-t border-[#c9dddd] pt-7 sm:flex sm:items-center sm:justify-between sm:gap-8">
          <div>
            <h2 className="text-[18px] font-semibold tracking-[-0.02em] text-[#1c2a27]">Interested in the MedHug platform?</h2>
            <p className="mt-1 max-w-[490px] text-[15px] leading-6 text-[#526661]">See how MedHug can support your medication-access workflow.</p>
          </div>
          <Link className="mt-4 inline-flex shrink-0 items-center text-[15px] font-semibold text-[#075eaf] hover:text-[#064f93] sm:mt-0" to="/signup">
            Schedule a call with the MedHug team
            <span aria-hidden="true" className="ml-2">→</span>
          </Link>
        </div>
      </section>
    </main>
  );
}
